export default "__VITE_ASSET__IHyP2Cma__"